<template>
    <!--    用户信息      -->
    <van-cell class="cell-padding" size="large" center
              v-if="model != null"
              :clickable="isAuthority"
              :is-link="isAuthority"
              :to="isAuthority ? to+ model.id:null">
      <div class="user-item">
        <div class="left align-center">
          <div class="user_head">
            <van-image
                round
                width="60px"
                height="60px"
                :src="model.headImgUrl">
            </van-image>
            <div class="avatarFrame" v-if="model.avatarFrameUrl">
              <img width="80px" height="80px" :src="model.avatarFrameUrl"/>
            </div>
            <van-tag v-if="model.levelName" class="level" type="primary" round size="medium">{{ model.levelName }}</van-tag>
          </div>
          <div class="padding-left-sm">
            <!-- id 已关注 黑名单 -->
            <div class="left-sm-tag">
              <van-tag plain type="primary">ID：{{ model.id }}</van-tag>
              <template v-if="shopSubscribe">
                <van-tag v-if="model.subscribe == 1" type="success">已关注</van-tag>
                <van-tag v-else plain>未关注</van-tag>
              </template>
              <van-tag v-if="$hasFeature('user_violation_share') && model.userViolationSignList && model.userViolationSignList.length > 0" plain color="#91d5ff" @click.stop.prevent="showViolation = true" >
                <a>{{ model.userViolationSignList.length }}条违规</a>
              </van-tag>
              <van-tag v-if="model.isBlacklist" type="default" color="black">黑名单</van-tag>
            </div>
            <!-- 用户昵称 1条违规 -->
            <div>
              <span>{{ model.name }}</span>
            </div>
            <!-- 推荐人：xxx -->
            <div v-if="model.distributorName" class="recommend">
              推荐人：{{ model.distributorName }}
            </div>
          </div>
        </div>
        <div class="right">
        </div>
      </div>
      <ViolationSelect :showViolation="showViolation" :userViolationSignList="model.userViolationSignList"
                       :showRole="'kf'"
                       @changeShowViolation="changeShowViolation"></ViolationSelect>
    </van-cell>
</template>

<script>
  import Vue from 'vue';
  import { Panel, Cell, CellGroup, Button, Tag, Icon, Toast, Dialog, Field, Uploader,Image } from 'vant';
  import Decimal from 'decimal.js';
  import moment from 'moment';
  import ViolationSelect from '@/components/common/violation-select'

  Vue.use(Panel)
      .use(Cell)
      .use(CellGroup)
      .use(Button)
      .use(Tag)
      .use(Icon)
      .use(Toast)
      .use(Dialog)
      .use(Field)
      .use(Uploader)
      .use(Image)

  export default {
    name: 'user-cell',
    components:{
      ViolationSelect
    },
    props:{
      model:null,
      to: {
        type: String
      },
      isAuthority: {
        type: Boolean,
        default: false
      },
      shopSubscribe: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
      }
    },
    methods: {
      formatDate(date, format) {
        if (!date) {
          return '';
        }
        if (!format) {
          format = 'YYYY-MM-DD'
        }
        return moment(date).format(format);
      },
      formatPrice(price) {
        if (price != null) {
          return Decimal.div(price, 100).toString()
        }
        return ''
      },
      // 格式化时间差
      formatTimeDiff(start, end,status) {
        start = moment(start)
        end = moment(end)
        const diffSeconds = end.diff(start, 'seconds')
        if (status === 2 && diffSeconds < 1) {
          return '即将完成'
        }
        if (diffSeconds < 60) {
          return `${diffSeconds}秒`
        }
        const diffMinutes = end.diff(start, 'minutes')
        if (diffMinutes < 60) {
          return `${diffMinutes}分钟`
        }
        const diffHours = end.diff(start, 'hours')
        if (diffHours < 24) {
          return `${diffHours}小时`
        }
        const diffDays = end.diff(start, 'days')
        return `${diffDays}天`
      },
    },
    mounted() {
    }
  }
</script>

<style lang="less" scoped>

.cell-padding{
  padding: 5px 15px 10px;

  .user-item {
    display: flex;
    align-items: center;
    .userMemo {
      color: #999;
    }
    .left {
      flex: 1;
      display: flex;
      .service-info {
        color: #333;
      }
      .created {
        color: #555;
        margin-bottom: 5px;
      }
      .user_head {
        position: relative;
        padding: 10px;
        .avatarFrame {
          position: absolute;
          top: 0;
          left: 0;
        }
        .level {
          position: absolute;
          left: 50%;
          height: 10px;
          font-size: 10px;
          white-space: nowrap;
          bottom: 0px;
          transform: translateX(-50%);
        }
      }
      .padding-left-sm div span{
        margin-right: 4px;
      }
      .recommend{
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #999999;
      }
    }
    .right {
      text-align: right;
      min-width: 30px;
      .total-amount {
        color: #333;
      }
    }
  }
}


</style>
